import React from 'react';
import VirtualizedSelect from 'react-virtualized-select';
import 'react-virtualized/styles.css';
import 'react-select/dist/react-select.css';
import 'react-virtualized-select/styles.css';

import TextField from './TextField';

export default function SelectField(props) {
  return (
    <TextField
      inputComponent={VirtualizedSelect}
      noStyle
      inputProps
      {...props}
      inputProps={{
        placeholder: 'Sélectionnez une option...',
        ...props.inputProps,
        simpleValue: true,
      }}
    />
  );
}



/** WEBPACK FOOTER **
 ** ./client/form/SelectField.js
 **/